import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiArrowRight } from 'react-icons/fi';
import axiosClient from '../../api/axiosClient';
import styles from './KycBanner.module.css';

const KycBanner: React.FC = () => {
  const [status, setStatus] = useState<string | null | 'loading'>('loading');

  useEffect(() => {
    axiosClient.get('/kyc/documents')
      .then(({ data }) => {
        const docs = data.documents || [];
        setStatus(docs.length > 0 ? docs[0].status : null);
      })
      .catch(() => setStatus(null));
  }, []);

  if (status === 'loading' || status === 'approved') return null;

  return (
    <div className={styles.banner}>
      <FiAlertTriangle />
      <span>
        {status === 'pending'
          ? "Your KYC is submitted and pending review — deposits and withdrawals will unlock once it's approved."
          : 'Complete your KYC before making a deposit or withdrawal.'}
      </span>
      <Link to="/dashboard/kyc" className={styles.link}>
        {status === 'pending' ? 'View KYC status' : 'Complete KYC'} <FiArrowRight />
      </Link>
    </div>
  );
};

export default KycBanner;
